import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Chip, IconButton, CircularProgress,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { adminFetch } from '../../lib/adminAuth';

export default function AdminResources() {
  const navigate = useNavigate();
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await adminFetch('/api/admin/resources');
      const data = await res.json();
      setResources(data.resources || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '-';

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a2e', mb: 0.5 }}>Resources</Typography>
          <Typography variant="body2" sx={{ color: '#999' }}>
            The four cards under &ldquo;Get more from Rewarding&rdquo; on the mobile home page. Edit their content here &mdash; the set itself is fixed.
          </Typography>
        </Box>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #f0f0f0', borderRadius: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, color: '#999', fontSize: 12 }}>Home card</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#999', fontSize: 12 }}>Title</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#999', fontSize: 12 }}>Sections</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#999', fontSize: 12 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#999', fontSize: 12 }}>Updated</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#999', fontSize: 12 }} align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={6} align="center" sx={{ py: 6 }}><CircularProgress size={24} /></TableCell></TableRow>
            ) : resources.length === 0 ? (
              <TableRow><TableCell colSpan={6} align="center" sx={{ py: 6, color: '#999' }}>No resources yet</TableCell></TableRow>
            ) : (
              resources.map((r) => (
                <TableRow key={r._id} hover sx={{ cursor: 'pointer' }} onClick={() => navigate(`/admin/resources/${r._id}`)}>
                  <TableCell>
                    <Chip label={r.card || r.slug} size="small" sx={{ fontSize: 11, bgcolor: '#fef9eb', color: '#b27a00' }} />
                  </TableCell>
                  <TableCell sx={{ fontSize: 13, fontWeight: 500 }}>{r.title}</TableCell>
                  <TableCell sx={{ fontSize: 13 }}>{r.sections?.length || 0}</TableCell>
                  <TableCell>
                    <Chip
                      label={r.published ? 'Published' : 'Draft'}
                      size="small"
                      sx={{ fontSize: 11, bgcolor: r.published ? '#e8f5e9' : '#f5f5f5', color: r.published ? '#2e7d32' : '#999' }}
                    />
                  </TableCell>
                  <TableCell sx={{ fontSize: 12 }}>{formatDate(r.updatedAt)}</TableCell>
                  <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                    <IconButton size="small" onClick={() => navigate(`/admin/resources/${r._id}`)}><EditIcon sx={{ fontSize: 16 }} /></IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
